// API Base URL
export const BACKEND_BASE_URI = process.env.REACT_APP_BACKEND_BASE_URI || 'https://finyantra.io/';

// Auth types (matching mobile app)
export const FACEBOOK_AUTH_TYPE = 'facebook';
export const GOOGLE_AUTH_TYPE = 'google';
export const PHONE_AUTH_TYPE = 'phone';
export const EMAIL_AUTH_TYPE = 'email';

// Storage Keys
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const AUTH_TYPE = 'AUTH_TYPE';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER_DATA = 'USER_DATA';
export const USER_ID = 'USER_ID';
export const THEME_MODE = 'THEME_MODE';

// Device dimensions (for responsive design)
export const getDeviceWidth = () => window.innerWidth;
export const getDeviceHeight = () => window.innerHeight;

// Screen breakpoints
export const BREAKPOINTS = {
  mobile: 640,
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
};

// Helper functions
export const moderateScale = (size: number, factor: number = 0.5): number => {
  const width = getDeviceWidth();
  const baseWidth = 375; // iPhone 11 Pro width
  const scale = width / baseWidth;
  const newSize = size + (scale - 1) * size * factor;
  return Math.round(newSize);
};

export const getHeight = (height: number): number => {
  const screenHeight = getDeviceHeight();
  return (screenHeight * height) / 100;
};

export const getWidth = (width: number): number => {
  const screenWidth = getDeviceWidth();
  return (screenWidth * width) / 100;
};

// Image helper
export const returnImageURIFromBytes = (imageBytes: string): string => {
  if (!imageBytes) return '';
  // If it's already a full URL, return it
  if (imageBytes.startsWith('http://') || imageBytes.startsWith('https://')) {
    return imageBytes;
  }
  // If it's base64, return with proper prefix
  if (imageBytes.startsWith('data:image')) {
    return imageBytes;
  }
  // Otherwise, assume it's base64 without prefix
  return `data:image/jpeg;base64,${imageBytes}`;
};
